import { render, staticRenderFns } from "./NextEventCard.vue?vue&type=template&id=5c41a126&"
import script from "./NextEventCard.vue?vue&type=script&lang=ts&"
export * from "./NextEventCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports